/**
 * Which drawing an icon uses at a given rendered size.
 *
 * The set is authored twice: a 16 grid (the default, and the only one every
 * icon has) and an optional 24 grid for icons that also need to read at
 * display sizes. They are not the same artwork scaled — a 16px drawing has
 * fewer, chunkier features so it survives being 16 pixels tall, and blowing it
 * up to 36 looks soft and over-simplified next to type. The 24 drawing carries
 * the detail that only becomes visible up there.
 *
 * The bands the design asks for:
 *
 *   10-18px -> the 16 drawing
 *   20-40px -> the 24 drawing
 *
 * so the switch sits at 20. Sizes outside either band still render — they take
 * whichever grid is nearer — because a hard error on `size={48}` would be a
 * worse outcome than a slightly soft icon.
 */

/** First rendered size that takes the 24 drawing. */
export const LARGE_GRID_FROM = 20;

/**
 * Whether `size` wants the 24 drawing.
 *
 * Note this reads the `size` PROP. A Tailwind class (`size-9`) changes the
 * rendered box without going through here, so an icon sized that way keeps the
 * 16 drawing however big it ends up. Pass `size` when the grid matters.
 */
export const prefersLargeGrid = (size: number = 16): boolean =>
	size >= LARGE_GRID_FROM;
